function createCanvasElement(tagName, className = '', text = null) {
  const element = document.createElement(tagName);
  if (className) element.className = className;
  if (text !== null) element.textContent = text;
  return element;
}

function createCanvasCard(artifact) {
  const card = createCanvasElement('article', 'aichat-canvas-card');
  const copy = document.createElement('div');
  copy.append(
    createCanvasElement('strong', '', artifact.title || '素材'),
    createCanvasElement('p', '', artifact.summary || '已整理的参考信息'),
  );
  const remove = createCanvasElement('button', '', '×');
  remove.type = 'button';
  remove.dataset.canvasRemove = artifact.id ?? '';
  remove.title = '从画布移除';
  card.append(createCanvasElement('span', '', artifact.source?.icon || '📄'), copy, remove);
  return card;
}

export function renderCanvas(root, { artifacts = [] } = {}) {
  if (!root) return;
  if (!artifacts.length) {
    root.replaceChildren(
      createCanvasElement('span', '', '画布'),
      createCanvasElement('p', '', '从「素材」中选择需要复用的分析结果。选中的素材会作为参考上下文带入下一次 Agent 任务。'),
    );
    return;
  }
  const header = createCanvasElement('div', 'aichat-canvas-header');
  const clear = createCanvasElement('button', '', '清空');
  clear.type = 'button';
  clear.dataset.canvasClear = '';
  header.append(createCanvasElement('span', '', `已选择 ${artifacts.length} 项素材`), clear);
  const list = createCanvasElement('div', 'aichat-canvas-list');
  list.append(...artifacts.map(createCanvasCard));
  const use = createCanvasElement('button', 'aichat-canvas-use', '用于下一次 Agent 任务');
  use.type = 'button';
  use.dataset.canvasUse = '';
  root.replaceChildren(header, list, use);
}
